<h2 mat-dialog-title>Create Custodian</h2>
<mat-dialog-content>
  <form [formGroup]="newCustodianForm">
    <mat-form-field style="width:100%">
      <mat-label>Type</mat-label>
      <mat-select class="mat-select-icon" formControlName="isOrganization">
        <mat-select-trigger>
          <mat-icon style="vertical-align: middle; margin-right: 16px">{{ newCustodianForm.controls['isOrganization'].value ? 'store_mall_directory' : 'face' }}</mat-icon>
          <span style="vertical-align: middle; margin:5px">{{ newCustodianForm.controls['isOrganization'].value ? 'Organization' : 'Person' }}</span>
        </mat-select-trigger>
        <mat-option [value]="false">
          <mat-icon>face</mat-icon><span style="margin:5px">Person</span>
        </mat-option>
        <mat-option [value]="true">
          <mat-icon>store_mall_directory</mat-icon><span style="margin:5px">Organization</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field style="padding-top: 15px; width: 100%">
      <input matInput placeholder="Name" formControlName="name" />
      <mat-error *ngIf="newCustodianForm.controls['name'].invalid && (newCustodianForm.controls['name'].touched || newCustodianForm.controls['name'].dirty)">
        <p *ngIf="newCustodianForm.controls['name'].errors.required">Name is <strong>required</strong></p>
        <p *ngIf="newCustodianForm.controls['name'].errors.maxlength">Name can not exceed <strong>256</strong> characters.</p>
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" [disabled]="!newCustodianForm.valid" (click)="ok()">Ok</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
